export const countries = [
    {
        country: "United Kingdom",
        countryCode: "GB",
    },
    {
        country: "Germany",
        countryCode: "DE",
    },
    {
        country: "France",
        countryCode: "FR",
    },
    {
        country: "Italy",
        countryCode: "IT",
    },
    {
        country: "Netherlands",
        countryCode: "NL",
    },
    {
        country: "Portugal",
        countryCode: "PT",
    },
    {
        country: "Spain",
        countryCode: "ES",
    },
    {
        country: "Sweden",
        countryCode: "SE",
    },
    {
        country: "Austria",
        countryCode: "AT",
    },
    {
        country: "Belgium",
        countryCode: "BE",
    },
    {
        country: "Czech Republic",
        countryCode: "CZ",
    },
    {
        country: "Denmark",
        countryCode: "DK",
    },
    {
        country: "Finland",
        countryCode: "FI",
    },
    {
        country: "Hungary",
        countryCode: "HU",
    },
    {
        country: "Iceland",
        countryCode: "IS",
    },
    {
        country: "Ireland",
        countryCode: "IE",
    },
    {
        country: "Luxembourg",
        countryCode: "LU",
    },
    {
        country: "Poland",
        countryCode: "PL",
    },
    {
        country: "Slovakia",
        countryCode: "SK",
    },
    {
        country: "Switzerland",
        countryCode: "CH",
    },
];

export const checkoutCountryList = [
    {
        country: "Austria",
        countryCode: "AT",
    },
    {
        country: "Belgium",
        countryCode: "BE",
    },
    {
        country: "Czech Republic",
        countryCode: "CZ",
    },
    {
        country: "Denmark",
        countryCode: "DK",
    },
    {
        country: "Finland",
        countryCode: "FI",
    },
    {
        country: "France",
        countryCode: "FR",
    },
    {
        country: "Germany",
        countryCode: "DE",
    },
    {
        country: "Guernsey",
        countryCode: "GG",
    },
    {
        country: "Hungary",
        countryCode: "HU",
    },
    {
        country: "Iceland",
        countryCode: "IS",
    },
    {
        country: "Ireland",
        countryCode: "IE",
    },
    {
        country: "Italy",
        countryCode: "IT",
    },
    {
        country: "Jersey",
        countryCode: "JE",
    },
    {
        country: "Luxembourg",
        countryCode: "LU",
    },
    {
        country: "Netherlands",
        countryCode: "NL",
    },
    {
        country: "Poland",
        countryCode: "PL",
    },
    {
        country: "Portugal",
        countryCode: "PT",
    },
    {
        country: "Slovakia",
        countryCode: "SK",
    },
    {
        country: "Spain",
        countryCode: "ES",
    },
    {
        country: "Sweden",
        countryCode: "SE",
    },
    {
        country: "Switzerland",
        countryCode: "CH",
    },
    {
        country: "United Kingdom",
        countryCode: "GB",
    },
];

export const currencies = [
    {
        currency: "GBP",
        currencyCode: "£",
    },
    {
        currency: "EUR",
        currencyCode: "€",
    },
];
